module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch08"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Lia opened the briefcase and took out one of the notebooks. She began counting the plastic boxes holding the voter cards. Every so often she pulled a box out, ostensibly to count the envelopes that held the cards, but actually to record the serial numbers on the envelopes to make the cards easier to find later on. One of the Ugandan UN women stood annoyingly close behind her as she worked, so close Lia nearly bumped into her several times. The survey took nearly a half hour; Lia was just finishing when Fernandez returned with a small folding table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry it took me so long,” he said, setting up the small card table. “I ended up having to go down the street to get one. The bank president wanted to bring an eight hundred-kilo mahogany desk down here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pick an envelope at random,” she told him, booting the computer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Any one?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“First one is up to you. The computer will generate the list from there. Something from the middle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fernandez walked to the wall of plastic boxes. One of the UN observers got up and stayed at his elbow as he tugged a box forward. He pulled it out about two-thirds of the way and tilted it forward just far enough so he could get the top envelope out. The eight or nine boxes on top of it nearly tumbled down on top of him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It’s going to be just luck that the envelope I need will be at the bottom of the pile, thought Lia as he brought the envelope over to be opened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, your chair,” said Fernandez. “I’ll be right back.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Dean leaned over the check-writing counter as Lia continued to talk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here we go,” said Lia, ostensibly talking to someone inside the vault.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The relay system used low-power, discreet-burst transmitters. The units could not be detected by conventional radio scanners or most other devices generally used to intercept radio signals—an important consideration, given that Dean and Karr had found two detectors operating in the lobby area when they had checked out the bank the day before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Looking good,” said Rockman. “We have the signal. You can pass the word on to Lia.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uh-huh.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Señor Garcia?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean looked up to find one of the bank officials standing over him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You wanted to open an account?” asked the man in Spanish.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, I do,” said Dean.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stall for a second if you can, Charlie,” said Rockman in his ear. “We have two more sets of numbers to go. The signal may degrade if you move and we’ll have to start over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I would like to open an account,” Dean told the bank officer, first in Spanish, then switching to English. “I, uh—my Spanish might not be that good, though. So if we could use English?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But of course,” said the banker. He smiled apologetically. “It is possible that your Spanish is better than my English.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mucho gracias")]), _vm._v(". But for money, and legal matters…I sometimes get nervous. If it is OK?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course,” said the banker. “Come this way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Another few seconds, Charlie,” said Rockman. “She’s just plugging in the third card from the envelope.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is it going to take long?” Dean said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just a few seconds,” said Rockman. “Tommy’s on his way in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I wasn’t talking to you, thought Dean.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Twenty minutes,” said the banker. “A few very easy things. You have a passport?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean reached into his jacket, pretending to fumble as he fished it out of his pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re good, Charlie. Go ahead.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Fernandez came back with the chair as Lia put the voter cards back in their box and returned them to the stack.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re ready for the next set of cards,” she told him. “Where do you think envelope B-5983 is?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That one, specifically?” said Fernandez.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s what the computer says. It generates a random pattern so that we spread out through the system,” said Lia. “We get fourteen envelopes with three cards apiece, selected for a statistical cross section of the production run.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The story was a bunch of bull, but it sounded good, and Fernandez nodded as if he understood what she was saying. While this selection didn’t matter, Lia wanted to introduce the pretense so that the third selection—and the eleven after that, if she decided to try to swap them all out at once—seemed routine. He found the box with help from her list and gave her the envelope. She slit it open and took out one of the cards, twirling it in her hand before pushing it in. The screen generated what looked like an old-fashioned TV test pattern, which dissolved into a multicolored mosaic. A series of numbers and letters filled the bottom two lines; the ID began on the top line at the left, in case she needed to read it off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So this screen tells you the card works?” asked Fernandez.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not precisely. It only tells me it’s not broken.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hovered over her as she put the cards into the reader. Lia went as slowly as she could; she’d heard Dean being called away but hadn’t heard anything from Karr yet, and the screen hadn’t blinked, which would have indicated the numbers had been uplinked and confirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she was done with the third card in the envelope, Lia got up, stretching as she resealed the envelope with a tape and tag that identified when it had been tested. As she did, the laptop blinked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What was that?” asked Fernandez, pointing at the screen. “It went out for a second.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know.” Lia reached over to the reader, pushing in the cord.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Problem?” asked Fernandez.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not sure. This cord may have been loose. Let’s run through that last envelope and make absolutely sure we’re OK. I don’t want to mess that up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Was that a stall, or did something really go wrong?” asked Karr, finally talking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not sure what the problem is,” Lia told Fernandez—though she was really talking to Karr. “Let’s do it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okey dokey,” said Karr.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lia knew that the lighthearted, almost joking tone in his voice was just Tommy being Tommy, but it still got under her skin. She knew that if she told him to be serious, he’d give her one of his dumbfounded looks and say, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yo, I am serious")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lia put the card into the reader slowly, fussing with the connector wire as if still not sure it was working properly. While she was running through the whole procedure again, Karr asked if she was going to take one card or get all twelve.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not sure,” mumbled Lia. One of the UN people had taken up a spot at her elbow. And Fernandez was so close she might not even be able to get one. She had to get rid of him somehow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right. They’re dumping the envelope numbers down to you now. You can just hit the function keys and you’ll see them,” said Karr.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Look at this,” Lia said to Fernandez, pointing to the lower left-hand corner of her computer screen. “My battery’s starting to wear down. This is just not my day. I’m down to sixty percent, and we’ve got a ways to go. I’m going to have to plug in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She rose and got the power cord from the briefcase.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There are no outlets in the safe,” said Fernandez.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh.” Lia feigned surprise. “Can we bring in another extension cord?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll see.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As soon as he was gone, Lia pulled out her notebook and jotted down the numbers, just in case something was wrong with the machine. Then she rose to get the envelope she needed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she did, Lia nearly knocked one of the UN women over. Surprised that she was so close, Lia shivered involuntarily. The woman followed her over to the boxes, so close she could feel the woman’s breath on her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Lia began to search for the envelope, her fingers began to tremble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wasn’t scared—she shouldn’t be scared—but…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But what?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry. I’m "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" sorry,” she told the woman standing next to her in Spanish. “But could you like, just give me a few feet? Sometimes I get claustrophobic.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman blinked at her but didn’t move back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’m not going to get all twelve cards, Lia thought to herself. I’ll be lucky to get even one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman stayed within six inches of her as Lia walked back to the laptop. Sitting down, she suddenly felt light-headed and then doubly spooked—first, somehow unnerved by the woman’s proximity, and second, unnerved that she had been unnerved. This sort of thing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v(" happened to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lia slit open the envelope, cutting through the tamper-evident tape. Her mind blanked. She couldn’t remember which of the several numbers that flashed on her computer screen were the ones that told her the chip’s serial number.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("First step, find which of the three cards she needed. Second step, swap it. Third step, leave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please give me a little space,” she told the UN observer. “You’re as close as my shadow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If the woman moved, it was less than an inch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One and out, Lia told herself. Just get the card and go.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The number was at the bottom of the screen, in the corner, right there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tommy was outside, and Dean was nearby. If she needed something, all she had to do was say so.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lia pushed the card in. It wasn’t the right one. She pulled it out, arranged it on top of the table next to the envelope. Would the next card be right?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That made it easier, didn’t it? Card three.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She turned to the UN monitor, standing over her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you want to see how this works?” Lia asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman didn’t respond.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you not speak Spanish?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I do,” said the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, could you move back then?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman took a baby step backward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you,” said Lia sarcastically.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her heart revved as she slipped her left hand to her belt and unhooked the replacement. She pulled the envelope into her lap, starting to hunch over so she could pretend to drop the envelope to the ground. Lia felt a pain in her throat, a sharp, stabbing pain, and for a moment her whole body was paralyzed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The envelope teetered on her lap. Just then, Fernandez came into the vault. She turned to glance at him and saw the monitor’s head had turned as well. In an instant, Lia had the cards swapped and was tucking the suspect one under the belt clasp.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her heart raced as she sealed the envelope with the new tape and sticker. Everything around her seemed tinged with a dull red light.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You know what? I think we’re done for today,” she said, rising slowly. She handed Fernandez the envelope. “I’m starting to get some jet lag.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not a problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wait,” said one of the UN observers as Lia started for the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A fresh wave of anxiety froze Lia in her place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You didn’t sign out on our form,” said the monitor. “You signed in. Now you have to sign out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course,” said Lia, hoping no one else noticed her hand was shaking.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbba7706","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429954921_ch08.vue
// module id = 90
// module chunks = 0